<script lang="ts">
  export let src: string;
  export let title: string;
  export let imgElement: HTMLImageElement;
</script>

<img {src} {title} alt="{title}" class="w-full" loading="lazy" bind:this="{imgElement}" on:load />
